// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mwg_effect024 {
  width: 100%;
  max-width: calc(100 * var(--vw));
  overflow-x: hidden;
  overflow-y: visible;
}

.mwg_effect024 .pin-height {
  height: 50vh;
}

.mwg_effect024 .container {
  position: relative;
  height: 50vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  max-width: calc(100 * var(--vw));
  box-sizing: border-box;
}

.mwg_effect024 .sentences {
  position: relative;
  font: 500 normal calc(10 * var(--vw))/1.2 'Satoshi', sans-serif;
  letter-spacing: -0.06em;
}

.mwg_effect024 .sentence {
  overflow: hidden;
}

.mwg_effect024 .sentence p {
  display: flex;
  white-space: nowrap;
  width: max-content;
  will-change: transform;
}

.mwg_effect024 .sentence2 {
  position: absolute;
  top: 0;
  left: 0;
}

.mwg_effect024 .sentence2 p {
  transform: translate(0, 100%);
}

.mwg_effect024 .glyph {
  width: calc(5.5 * var(--vw));
  height: auto;
  display: inline-block;
  vertical-align: middle;
  object-fit: contain;
  margin: 0 calc(1.5 * var(--vw));
}

/* ==================== MEDIA QUERIES ==================== */

/* Mobile (max-width: 768px) */
@media (max-width: 768px) {
  .mwg_effect024 {
    background: #121212;
    color: #ffffff;
    overflow-x: hidden;
  }

  .mwg_effect024 .pin-height {
    height: auto !important;
    min-height: 30vh;
  }

  .mwg_effect024 .container {
    height: 30vh !important;
    min-height: 30vh;
    position: relative !important;
    padding: 0 !important;
  }

  .mwg_effect024 .sentences {
    font-size: calc(8 * var(--vw)) !important;
    font-weight: 500 !important;
    line-height: 1.2 !important;
    letter-spacing: -0.03em !important;
  }

  .mwg_effect024 .sentence {
    position: relative !important;
    overflow: hidden !important;
    height: 100%;
  }

  .mwg_effect024 .sentence2 {
    display: none !important; /* Hide second sentence on mobile, use simple one-way animation */
  }

  .mwg_effect024 .sentence p {
    display: flex !important;
    white-space: nowrap !important;
    width: max-content !important;
    animation: scroll-left-mobile 5s linear infinite !important;
  }

  .mwg_effect024 .sentence2 p {
    transform: none !important;
  }

  .mwg_effect024 .glyph {
    width: calc(4 * var(--vw)) !important;
    height: auto !important;
    display: inline-block !important;
    vertical-align: middle !important;
    object-fit: contain !important;
    margin: 0 calc(2 * var(--vw)) !important;
  }
}

/* CSS Animation for mobile - scroll from right to left */
@keyframes scroll-left-mobile {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

/* Small Mobile (max-width: 480px) */
@media (max-width: 480px) {
  .mwg_effect024 .pin-height {
    min-height: 25vh;
  }

  .mwg_effect024 .container {
    height: 25vh !important;
    min-height: 25vh;
  }

  .mwg_effect024 .sentences {
    font-size: calc(10 * var(--vw)) !important;
  }
}


`, "",{"version":3,"sources":["webpack://./src/component/running-text/running-text.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,+DAA+D;EAC/D,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA,4DAA4D;;AAE5D,8BAA8B;AAC9B;EACE;IACE,mBAAmB;IACnB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;IAChB,6BAA6B;IAC7B,qBAAqB;EACvB;;EAEA;IACE,yCAAyC;IACzC,2BAA2B;IAC3B,2BAA2B;IAC3B,kCAAkC;EACpC;;EAEA;IACE,6BAA6B;IAC7B,2BAA2B;IAC3B,YAAY;EACd;;EAEA;IACE,wBAAwB,EAAE,iEAAiE;EAC7F;;EAEA;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,6BAA6B;IAC7B,2DAA2D;EAC7D;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,qCAAqC;IACrC,uBAAuB;IACvB,gCAAgC;IAChC,iCAAiC;IACjC,8BAA8B;IAC9B,wCAAwC;EAC1C;AACF;;AAEA,yDAAyD;AACzD;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA,oCAAoC;AACpC;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,0CAA0C;EAC5C;AACF","sourcesContent":[".mwg_effect024 {\n  width: 100%;\n  max-width: calc(100 * var(--vw));\n  overflow-x: hidden;\n  overflow-y: visible;\n}\n\n.mwg_effect024 .pin-height {\n  height: 50vh;\n}\n\n.mwg_effect024 .container {\n  position: relative;\n  height: 50vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  width: 100%;\n  max-width: calc(100 * var(--vw));\n  box-sizing: border-box;\n}\n\n.mwg_effect024 .sentences {\n  position: relative;\n  font: 500 normal calc(10 * var(--vw))/1.2 'Satoshi', sans-serif;\n  letter-spacing: -0.06em;\n}\n\n.mwg_effect024 .sentence {\n  overflow: hidden;\n}\n\n.mwg_effect024 .sentence p {\n  display: flex;\n  white-space: nowrap;\n  width: max-content;\n  will-change: transform;\n}\n\n.mwg_effect024 .sentence2 {\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.mwg_effect024 .sentence2 p {\n  transform: translate(0, 100%);\n}\n\n.mwg_effect024 .glyph {\n  width: calc(5.5 * var(--vw));\n  height: auto;\n  display: inline-block;\n  vertical-align: middle;\n  object-fit: contain;\n  margin: 0 calc(1.5 * var(--vw));\n}\n\n/* ==================== MEDIA QUERIES ==================== */\n\n/* Mobile (max-width: 768px) */\n@media (max-width: 768px) {\n  .mwg_effect024 {\n    background: #121212;\n    color: #ffffff;\n    overflow-x: hidden;\n  }\n\n  .mwg_effect024 .pin-height {\n    height: auto !important;\n    min-height: 30vh;\n  }\n\n  .mwg_effect024 .container {\n    height: 30vh !important;\n    min-height: 30vh;\n    position: relative !important;\n    padding: 0 !important;\n  }\n\n  .mwg_effect024 .sentences {\n    font-size: calc(8 * var(--vw)) !important;\n    font-weight: 500 !important;\n    line-height: 1.2 !important;\n    letter-spacing: -0.03em !important;\n  }\n\n  .mwg_effect024 .sentence {\n    position: relative !important;\n    overflow: hidden !important;\n    height: 100%;\n  }\n\n  .mwg_effect024 .sentence2 {\n    display: none !important; /* Hide second sentence on mobile, use simple one-way animation */\n  }\n\n  .mwg_effect024 .sentence p {\n    display: flex !important;\n    white-space: nowrap !important;\n    width: max-content !important;\n    animation: scroll-left-mobile 5s linear infinite !important;\n  }\n\n  .mwg_effect024 .sentence2 p {\n    transform: none !important;\n  }\n\n  .mwg_effect024 .glyph {\n    width: calc(4 * var(--vw)) !important;\n    height: auto !important;\n    display: inline-block !important;\n    vertical-align: middle !important;\n    object-fit: contain !important;\n    margin: 0 calc(2 * var(--vw)) !important;\n  }\n}\n\n/* CSS Animation for mobile - scroll from right to left */\n@keyframes scroll-left-mobile {\n  0% {\n    transform: translateX(0);\n  }\n  100% {\n    transform: translateX(-50%);\n  }\n}\n\n/* Small Mobile (max-width: 480px) */\n@media (max-width: 480px) {\n  .mwg_effect024 .pin-height {\n    min-height: 25vh;\n  }\n\n  .mwg_effect024 .container {\n    height: 25vh !important;\n    min-height: 25vh;\n  }\n\n  .mwg_effect024 .sentences {\n    font-size: calc(10 * var(--vw)) !important;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
